import { zSchema } from "@zeal/common";

export const getKybEvaluationsRequestSchema = zSchema.object({
  testMode: zSchema.boolean().optional(),
});

export type TGetKybEvaluationsRequestSchema = zSchema.infer<
  typeof getKybEvaluationsRequestSchema
>;

export const kybEvaluationSchema = zSchema.object({
  id: zSchema.string(),
  external_id: zSchema.string().nullable().optional(),
  unique_external_id: zSchema.string().nullable().optional(),
});

export const getKybEvaluationsResponseSchema =
  zSchema.array(kybEvaluationSchema);

export type TGetKybEvaluationsResponseSchema = zSchema.infer<
  typeof getKybEvaluationsResponseSchema
>;
